module.exports = __webpack_public_path__ + "ca.2dd02bb05ef9354dbca0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ca.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ca.svg
// module chunks = styles